import React from "react";
import {Badge, DescriptionListItem} from "peggirkit";
import SlimContainer from "../layout/SlimContainer";
import {useIntl} from "react-intl";
import DescriptionListCard from "@widgets/descriptionList/DescriptionListCard";

declare const __APP_VERSION__: string;
declare const __BUILD_DATE__: string;

const SystemInfoOverview = () => {
    const intl = useIntl();

    return (
        <SlimContainer center={false}>
            <DescriptionListCard
                title={intl.formatMessage({id: "appInfo"})}
                description={intl.formatMessage({id: "appInfoDescription"})}
            >
                <DescriptionListItem
                    title={"eataliano-frontend-admin"}
                    content={
                        <div className={"flex flex-row items-center justify-start gap-2"}>
                            <Badge>
                                {__APP_VERSION__}
                            </Badge>
                            <p>
                                {new Date(__BUILD_DATE__).toLocaleString()}
                            </p>
                        </div>
                    }
                />
            </DescriptionListCard>
        </SlimContainer>
    );
};

export default SystemInfoOverview;